import { DsChartsPinData } from './ds-charts-pin-data.class';
import { DsChartsPinStatisticsInterface } from '../interfaces/ds-charts-pin-statistics.interface';
import { DS_PINS_COUNT_STATUS_ID } from '../constants/pin-count-id.constant';

/**
 * Contains the number of one pin state over time, to draw with Chart.js
 */
export class DsChartsPinStatistics {
  /**
   * List of chart series
   */
  pinStatistics: DsChartsPinData[];

  /**
   * Labels to display on the X axis. To display dates, the labels can be given as 'YYYY-MM-DD'
   */
  labels: string[];

  /**
   * Creates an instance of DsChartsPinStatistics.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsChartsPinStatisticsInterface) {
    if (jsonData.pinStatistics) {
      this.pinStatistics = jsonData.pinStatistics.map((data) => {
        if (data.state === 'COUNT') data.state = DS_PINS_COUNT_STATUS_ID;
        return new DsChartsPinData(data);
      });
    }
    this.labels = jsonData.labels;
  }
}
